/* © 2026 Trinchebalk */
(() => {
  document.querySelectorAll('[data-seo-disclosure]').forEach(box => {
    const button = box.querySelector('[data-seo-toggle]');
    if (!button || button.dataset.ready) return; button.dataset.ready = 'true';
    const full = box.querySelector('.tb-seo-collapse');
    const text = [...full.querySelectorAll('p,h2,h3,li')].map(n => n.textContent.trim()).join(' ') || full.textContent.trim();
    const limit = 180, cut = text.length > limit ? text.lastIndexOf(' ', limit) : text.length;
    const excerpt = document.createElement('p'); excerpt.className = 'tb-seo-excerpt';
    excerpt.textContent = text.length > limit ? text.slice(0, cut > 0 ? cut : text.indexOf(' ', limit) > 0 ? text.indexOf(' ', limit) : text.length).trimEnd() + '…' : text;
    full.before(excerpt); full.hidden = true;
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      full.hidden = !open; excerpt.hidden = open;
      box.querySelector('.tb-seo-collapse').classList.toggle('is-open', open);
      button.textContent = open ? button.dataset.less : button.dataset.more;
    });
  });
})();
